import { isDev } from ".";
import { isDeveloperDev } from "./isDev";
import _ from "lodash";

export {
    logInDev,
    showComponentInDev,
    exeDevOrProd,
    isDev,
    isDeveloperDev,
    isPartnerDev,
    isLocalHost,
} from "./isDev";
export { getIsSale } from "./isSale";
export { isDeliverConditionFullfilled, getDeliverCost } from "./isDeliver";

export function removeAfterDash(input) {
    return input.split("-")[0];
}

export function mapIdToPrice(subitemList, id) {
    return subitemList.filter((sub) => String(sub.id) === String(id))[0].price;
}

export function getTotalPriceStr(orderList) {
    return orderList
        .reduce((acc, cur) => acc + cur.price * cur.quantity, 0)
        .toFixed(2);
}

export function isFavorate(name, favorite) {
    return favorite.includes(name);
}

export function findSortFromMenu(name, menu) {
    if (isDev) console.log({ name });
    for (let first in menu) {
        for (let second in menu[first]) {
            if (Object.keys(menu[first][second]).includes(name)) {
                return { first: first, second: second };
            }
        }
    }
    return undefined;
}

export function getPartnerName() {
    let partnerName = "taumi";
    const nameList = window.location.href.split(/\/|:|\.|-/);
    if (nameList.includes("taumi")) partnerName = "Taumi";
    if (nameList.includes("komari")) partnerName = "Komari";
    return partnerName;
}

export function getOrderNum(orders) {
    return orders.reduce((arr, cur) => arr + cur.quantity, 0);
}

export function getDiscountMenu(discountMenu) {
    const date = new Date();
    const dayIndex = date.getDay();
    const discountKey = Object.keys(discountMenu).filter((key) =>
        key.includes(isDeveloperDev ? 2 : dayIndex)
    );
    const result = _.merge(...discountKey.map((key) => discountMenu[key]));
    return result;
}
